export enum ExemptionFormTypeEnum {
    GNH = 1,
    LVCommute = 2
}

export const ExemptionFormTypeEnumToString = ((option: ExemptionFormTypeEnum) => {
    switch (option) {
        case ExemptionFormTypeEnum.GNH:
            return 'GNH Driving';
        case ExemptionFormTypeEnum.LVCommute:
            return 'LV Commute';
        default: ''
    }
});